import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
export function UniqueMechanism() {
  const steps = ['No tomas 20 decisiones', 'Tomas 1 decisión pequeña', 'La ejecutas en calma por un tiempo corto', 'Si no funciona, no te culpas: cambias de ruta'];
  return <section className="w-full bg-[#faf7f2] py-20 px-4" data-id="element-348">
      <div className="max-w-[680px] mx-auto" data-id="element-349">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-350">
          <h2 className="font-serif text-3xl md:text-4xl text-[#0f172a] mb-8" data-id="element-351">
            Por Qué Esto Es Distinto
          </h2>

          <p className="text-xl md:text-2xl text-[#2d2926] mb-12 font-light leading-relaxed" data-id="element-352">
            La mayoría de recursos te dan ideas. <br data-id="element-353" />
            <span className="font-serif italic text-[#5b8a7a] font-medium" data-id="element-354">
              Esto te da secuencia.
            </span>
          </p>

          <div className="space-y-4 relative" data-id="element-355">
            <div className="absolute left-[19px] top-4 bottom-4 w-[2px] bg-[#e2e8f0]" data-id="element-356" />

            {steps.map((step, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.15
          }} className="relative flex items-center gap-6" data-id="element-357">
                <div className="w-10 h-10 rounded-full bg-white border-2 border-[#5b8a7a] flex items-center justify-center shrink-0 z-10 shadow-sm" data-id="element-358">
                  <span className="text-[#5b8a7a] font-bold text-sm" data-id="element-359">
                    {i + 1}
                  </span>
                </div>
                <div className="bg-white p-4 rounded-lg shadow-sm border border-[#f1f5f9] flex-1" data-id="element-360">
                  <p className="text-[#0f172a] font-medium" data-id="element-361">{step}</p>
                </div>
              </motion.div>)}
          </div>

          <p className="mt-12 text-lg text-[#64748b] text-center italic" data-id="element-362">
            Es exactamente lo que tu cerebro necesita cuando está en modo
            supervivencia.
          </p>
        </motion.div>
      </div>
    </section>;
}